import React, { useContext, useEffect, useRef, useState } from 'react'
import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewExEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewExEx';
import PurchaseOrderEdit from './PurchaseOrderEdit';
import moment from 'moment';
import { Button, Select, Tooltip, Image, DatePicker, Popconfirm, Checkbox } from 'antd';
import { httpGet } from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import getList from '../../universal/getList';
import ProductEdit from './ProductEdit';
import orderCutKey from '../../../generalMethod/OrderCutKey';
import setOrderDate from '../../../generalMethod/setOrderDate';
import dayjs from 'dayjs';
import entrepotPrint from '../../../generalMethod/entrepotPrint';
import orderPeration from '../../../generalMethod/orderPeration';
import CancelOrder from './CancelOrder';
import { SocketContext } from '../../../App';
import PurchaseOrder from './PurchaseOrder';

let wmService: any = systemConfig.wmService;

export default function PurchaseOrderEx(props: any) {


    /** api服务id */
    const apiId = 'purchaseOrder';
    const ref = useRef<any>(undefined);
    /** 后端数据wmService */


    // const [aaOpen, setAaOpen] = useState<boolean>(false)
    // const aa = () => {
    //     setAaOpen(true)
    // }
    return (
        <>
            <PurchaseOrder data={{ isBigOrder: true, handleEditAuthority: { orderStatus: [1, 2] }, handleDelectAuthority: { orderStatus: [1, 2] } }}
            ></PurchaseOrder >

        </>
    )
}
